@if (configItem?.featureName) {
    <div class="feature-check">
        <dx-check-box text="Enable {{ enableFeatureText }}"
                      data-test="enable-feature-checkbox"
                      [value]="isFeatureEnabled"
                      (valueChange)="onFeatureStatusValueChanged($any($event))"></dx-check-box>
    </div>
}

@if (isFeatureEnabled) {
    <div class="feature-detail">
        <ng-container [ngTemplateOutlet]="projectedContent"></ng-container>
    </div>
}

<ng-template #projectedContent>
    <ng-content></ng-content>
</ng-template>
